import { calculateExtraStatisticsFields } from './utils'
import _ from 'lodash'

// Statistics grouped by type
export default class Overall {
  constructor(statistics) {
    this.statistics = statistics
  }

  calculate() {
    const spent = _.sumBy(this.statistics, (s) => (_.isNull(s.spent) ? 0 : parseFloat(s.spent)))
    const clicks = _.sumBy(this.statistics, 'clicks')
    const impressions = _.sumBy(this.statistics, 'impressions')
    const counterImpressions = _.sumBy(this.statistics, 'counterImpressions')
    const goals = _(this.statistics)
      .map((stat) => stat.goals)
      .flatten()
      .sum()

    return [
      calculateExtraStatisticsFields({
        spent,
        clicks,
        impressions,
        counterImpressions,
        goals
      })
    ]
  }
}
